import { type CSSProperties } from 'react';

export const DROPDOWN_TRIGGER_ATTR = 'data-malachite-dropdown-trigger';

const CARD_BACKGROUND = 'var(--malachite-card-background, rgb(255, 255, 255))';
const DISABLED_BACKGROUND = 'var(--malachite-dropdown-disabled-background, rgb(241, 241, 241))';
const DISABLED_TEXT = 'var(--malachite-text-placeholder, rgb(187, 187, 187))';

const BORDER = {
    disabled: 'var(--malachite-dropdown-border, rgb(232, 232, 232))',
    active: 'var(--malachite-dropdown-border-active, rgba(0, 175, 102, 0.6))',
    filter: 'var(--malachite-dropdown-border-filter, rgba(0, 175, 102, 0.4))',
    error: 'var(--malachite-dropdown-border-error, rgba(239, 55, 55, 0.6))',
    pending: 'var(--malachite-dropdown-border-pending, rgba(241, 139, 10, 0.6))',
} as const;

const SHADOW = {
    disabled: 'var(--malachite-dropdown-shadow, 0px 1px 0px 0px rgba(0, 0, 0, 0.15))',
    active: 'var(--malachite-dropdown-shadow-active, 0px 1px 0px 0px rgba(0, 175, 102, 0.8))',
    filter: 'var(--malachite-dropdown-shadow-filter, 0px 1px 0px 0px rgba(0, 175, 102, 0.6))',
    error: 'var(--malachite-dropdown-shadow-error, 0px 1px 0px 0px rgba(239, 55, 55, 0.8), 0px 0px 0px 2px rgba(239, 55, 55, 0.1))',
    pending:
        'var(--malachite-dropdown-shadow-pending, 0px 1px 0px 0px rgba(241, 139, 10, 0.8), 0px 0px 0px 2px rgba(241, 139, 10, 0.1))',
} as const;

export type DropdownTone = 'default' | 'pending';

export interface TriggerVisualState {
    disabled?: boolean;
    error?: boolean;
    tone?: DropdownTone;
    open?: boolean;
    loading?: boolean;
    hasSelection?: boolean;
}

export function getTriggerVisual({
    disabled,
    error,
    tone,
    open,
    loading,
    hasSelection,
}: TriggerVisualState): CSSProperties {
    if (disabled) {
        return {
            backgroundColor: DISABLED_BACKGROUND,
            borderColor: BORDER.disabled,
            boxShadow: error ? SHADOW.error : SHADOW.disabled,
            color: DISABLED_TEXT,
        };
    }
    const base: CSSProperties = { backgroundColor: CARD_BACKGROUND };
    if (loading) {
        base.opacity = 0.6;
    }
    if (error) {
        return { ...base, borderColor: BORDER.error, boxShadow: SHADOW.error };
    }
    if (tone === 'pending') {
        return { ...base, borderColor: BORDER.pending, boxShadow: SHADOW.pending };
    }
    if (loading) {
        return { ...base, borderColor: BORDER.filter, boxShadow: SHADOW.filter };
    }
    if (open) {
        return { ...base, borderColor: BORDER.active, boxShadow: SHADOW.active };
    }
    if (hasSelection) {
        return { ...base, borderColor: BORDER.filter, boxShadow: SHADOW.filter };
    }
    return base;
}
